export default "__VITE_ASSET__CjxdS0az__"